import { getApiBaseUrl } from '../utils/apiBaseUrl';

// contentful
export const CONTENTFUL_BASE_URL = 'https://cdn.contentful.com';
export const SPACE_ID = 'n0z8m0uvv6qx';
export const ACCESS_TOKEN = 'P9oKEEwrl3Q_sf5e8wgXDoyQtPEeZiIPpD726QfaPQU';

// Resolved by the shared module so SSPR, SSR and the main app all agree (and
// all honour the API_URL override).
export const API_BASE_URL_SSPR = getApiBaseUrl();

// URL key
export const CITIES_PAGE_URL = `${CONTENTFUL_BASE_URL}/spaces/${SPACE_ID}/entries?access_token=${ACCESS_TOKEN}&content_type=city&include=5&limit=1000`;
export const SHOPS_CITIES_URL = `${API_BASE_URL_SSPR}/shops/cities`;
